import { loadCollectionItems } from '../pluginComponentApi';

export default async function (editor, opt = {}) {
  const { projectId, version } = opt;
  const traitManager = editor.TraitManager;
  const permissionItems = await loadCollectionItems(projectId, version, 'permission');

  traitManager.addType('permission-trait', {
    createInput({ trait }) {
      let input = document.createElement('select');
      let attrId = document.createAttribute('id');
      attrId.value = 'drapcode-permission-select';
      input.setAttributeNode(attrId);

      let defaultOption = document.createElement('option');
      defaultOption.text = '- Select One -';
      defaultOption.value = '';
      input.append(defaultOption);

      for (let i = 0; i < permissionItems.length; i++) {
        let name = permissionItems[i].name;
        let value = `${permissionItems[i].name}`;
        let option = document.createElement('option');
        option.text = name;
        option.value = value;
        input.append(option);
      }

      return input;
    },
    onEvent({ elInput, component }) {
      const value = this.model.get('value');

      if (value) {
        const allTraits = component.get('traits');
        const traitsSize = allTraits.length;
        const permissions = allTraits.filter(
          (trait) => trait.attributes['type'] === 'permission-trait',
        );

        component.addTrait(
          {
            type: `permission-trait`,
            name: `permission-${permissions.length}`,
            label: `Permission #${permissions.length}`,
          },
          { at: traitsSize },
        );
      }
    },
    onUpdate({ elInput, component }) {
      const attr = component.getAttributes();
      const name = this.model.get('name');

      elInput.value = attr[name] ? attr[name].trim() : '';
    },
  });
}
